import siteObjectToQuery from "../utils/siteObjectToQuery";
import filterObjectToQuery from "../utils/filterObjectToQuery";
import api from "../axios/api";
import { IUser } from "../models/iuser";
import { IPayload } from "../models/ipayload";
import { ISite } from "../models/isite";
import { IRole } from "../models/irole";
import Axios, { AxiosResponse } from "axios";
let CancelToken = Axios.CancelToken;
let fetchUsersExport_cancel: any;


export const fetchUserService = (page: number, limit: number, search: string, order: string, orderBy: string, sites: Array<ISite>, roles: Array<IRole>): Promise<{data: IPayload<IUser>}> => {
  let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
  queryParams += `${sites && sites.length > 0 ? '&sites=' + siteObjectToQuery(sites) : ''}`
  queryParams += `${roles && roles.length > 0 ? '&roles=' + filterObjectToQuery(roles) : ''}`
  return api.get('/users' + queryParams)
};

export const fetchValidUsersService = (page: number, limit: number, search: string, order: string, orderBy: string): Promise<AxiosResponse<IPayload<IUser>>> => {
  const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
  return api.get('/users/tenantvalidusers' + queryParams)
};

export const fetchUsersExportService = (search: string, order: string, orderBy: string, sites: Array<ISite>, roles: Array<IRole>, emailLanguage: string): Promise<IPayload<IUser>> => {
  fetchUsersExport_cancel && fetchUsersExport_cancel()

	let queryParams = `?q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
	queryParams += `${sites && sites.length > 0 ? '&sites=' + siteObjectToQuery(sites) : ''}`
	queryParams += `${roles && roles.length > 0 ? '&roles=' + filterObjectToQuery(roles) : ''}`
	queryParams += `${emailLanguage && emailLanguage.length > 0 ? `&emailLanguage=${emailLanguage}` : '&emailLanguage=pt'}`
	

	return api.get('/users/export' + queryParams, {
		cancelToken: new CancelToken(function executor(c) {
			fetchUsersExport_cancel = c;
		})
	})

}
